export enum TimeInterval {
  quarterHour = 1,
  halfHour = 2,
  hour = 4,
  twoHours = 8,
  eightHours = 32,
}
